module.exports = __webpack_public_path__ + "static/media/previous_order.1f73c1b9.svg";